<!--
    @步骤页-步骤流程
-->
<template>
    <div class="steps-box">
        <div
                v-for="(item, index) in stepsData"
                class="steps-card"
                :class="index == stepsIndex ? 'on' : index < stepsIndex ? 'past' : ''"
                :key="index">
            <span>{{ index + 1 }}</span>
            <span>{{ item.name }}</span>
            <span class="linIcon"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "steps",
        props:{
            stepsData:{
                type:Array,
            },
            stepsIndex:{
                type:Number,
            },
        },
        created() {

        },
        methods: {
            //下一步
            stepsFun() {
                this.stepsIndex = this.$parent.stepsIndex;
            },
        },
    };
</script>

<style lang="scss" scoped>
    /*    steps-box*/
    .steps-box {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 20px;
        margin-left: 45px;
        .steps-card {
            cursor: pointer;
            display: flex;
            align-items: center;
            color: rgba(0, 0, 0, 0.25);
            position: relative;
            margin-left: 16px;
            span:nth-of-type(1) {
                display: inline-block;
                width: 32px;
                height: 32px;
                text-align: center;
                line-height: 32px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                border-radius: 50%;
                margin-right: 8px;
                font-size: 16px;
                color: rgba(0, 0, 0, 0.25);
                i {
                    font-style: normal;
                }
            }
            span:nth-of-type(2) {
                font-size: 16px;
                font-family: MicrosoftYaHei;
                color: rgba(0, 0, 0, 0.45);
            }
            .linIcon{
                width: 192px;
                height: 1px;
                background: rgba(0, 0, 0, 0.15);
                margin-left: 16px;
            }
        }
        .steps-card:last-of-type {
            .linIcon{
                width: 0;
            }
        }
        .steps-card.on {
            display: flex;
            align-items: center;
            color: rgba(0, 0, 0, 0.85);
            span:nth-of-type(1) {
                display: inline-block;
                width: 32px;
                height: 32px;
                text-align: center;
                line-height: 32px;
                background: #1890FF;
                border: 1px solid #1890FF;
                color: #fff;
                border-radius: 50%;
                margin-right: 8px;
            }
            span:nth-of-type(2) {
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: bold;
                color: #000000;
            }
        }
        .steps-card.past {
            display: flex;
            align-items: center;
            color: rgba(0, 0, 0, 0.85);
            span:nth-of-type(1) {
                display: inline-block;
                width: 32px;
                height: 32px;
                text-align: center;
                line-height: 32px;
                background: #1890FF;
                border: 1px solid #1890FF;
                color: #fff;
                border-radius: 50%;
                margin-right: 8px;
            }
            span:nth-of-type(2) {
                font-size: 16px;
                font-family: MicrosoftYaHei;
                color: rgba(0, 0, 0, 0.85);
            }
        }
        /*.steps-card.on {*/
        /*    .linIcon{*/
        /*        background: #1890FF;*/
        /*    }*/
        /*}*/
        .steps-card.past {
            .linIcon{
                background: #1890FF;
            }
        }
    }
</style>